import { ScaleLoader } from "react-spinners";

function Loading({ theme = "light" }: { theme: "light" | "dark" }) {
    return (
        <main className="flex h-[300px] items-center justify-center">
            <ScaleLoader
                color={theme === "dark" ? "white" : "black"}
                width={8}
                height={50}
                radius={4}
            />
        </main>
    );
}

function LoadingPage({ theme = "light" }: { theme: "light" | "dark" }) {
    return (
        <main className="flex min-h-[80dvh] w-full items-center justify-center">
            <Loading theme={theme} />
        </main>
    );
}

function LoadingFullScreen({ theme = "light" }: { theme: "light" | "dark" }) {
    return (
        <div className="card fixed left-0 top-0 z-50 flex h-dvh w-full items-center justify-center rounded-none border-none">
            <Loading theme={theme} />
        </div>
    );
}

export { Loading, LoadingFullScreen, LoadingPage };
